import React from 'react'
import Header from '../components/Header';
import Profile from '../components/Profile';

export const ProfilePage = () => {
    
    return (
        <>
            <Header signOutButton/>
            <Profile/>
            
        </>
    )
}
